import React, {forwardRef, useEffect, useRef, useState} from 'react';
import './header.scss';
import RightDropdownArrow from "../images/RightDropdownArrow";
import HeaderProductsItem from "./components/HeaderProductsItem";
import RightProductArrow from "../images/RightProductArrow";
import HeaderCompanyItem from "./components/HeaderCompanyItem";
import HeaderSocialItem from "./components/HeaderSocialItem";
import { useNavigate } from "react-router";
import RightDropdownArrowMobile from "../images/RightDropdownArrowMobile";
import HeaderProductsItemMobile from "./components/HeaderProductsItemMobile";

interface HeaderProps {
	mode: 'dark' | 'light';
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(({ mode }, ref) => {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState({
		products: false,
		company: false,
	});
	const productsRef = useRef<HTMLDivElement>(null);
	const companyRef = useRef<HTMLDivElement>(null);
	const adaptiveRef = useRef<HTMLDivElement>(null);
	const [isHoveredSomeCool, setIsHoveredSomeCool] = useState(false);
	const [isAdaptiveMenuOpen, setIsAdaptiveMenuOpen] = useState(false);
	const productsButtonRef = useRef<HTMLButtonElement>(null);
	const companyButtonRef = useRef<HTMLButtonElement>(null);
	const [width, setWidth] = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (
				productsRef.current && !productsRef.current.contains(e.target as Node) &&
				productsButtonRef.current && !productsButtonRef.current.contains(e.target as Node) &&
				width > 768
			) {
				setIsOpen((prevState: any) => ({
					...prevState,
					products: false,
				}));
				setIsAdaptiveMenuOpen(false);
			}
			if (
				companyRef.current && !companyRef.current.contains(e.target as Node) &&
				companyButtonRef.current && !companyButtonRef.current.contains(e.target as Node) &&
				width > 768
			) {
				setIsOpen((prevState: any) => ({
					...prevState,
					company: false,
				}));
				setIsAdaptiveMenuOpen(false);
			}
			if (
				adaptiveRef.current && !adaptiveRef.current.contains(e.target as Node) && width < 768
			) {
				setIsAdaptiveMenuOpen(false);
			}
		};

		if (isOpen["products"] || isOpen["company"] || isAdaptiveMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	const handleOpened = (prop: string) => {
		if (width < 768) {
			console.log("prop: ", prop);
			setIsOpen((prevState: any) => ({
				products: prop === "products" ? !prevState.products : false,
				company: prop === "company" ? !prevState.company : false,
			}));
		} else {
			console.log("setIsAdaptiveMenuOpen(false)");
			setIsAdaptiveMenuOpen(false);
		}
	};

	const handleHoverOpened = (prop: string) => {
		if (width > 767) {
			if (prop === "products" || prop === "company") {
				setIsOpen({
					products: prop === "products",
					company: prop === "company",
				});
			} else {
				setIsOpen({
					products: false,
					company: false
				});
			}
			// setIsAdaptiveMenuOpen(false);
		}
	};

	const handlePressBurger = () => {
		if (isOpen["products"] || isOpen["company"]) {
			setIsOpen({
				products: false,
				company: false,
			});
			setIsAdaptiveMenuOpen(false);
		} else {
			setIsAdaptiveMenuOpen(!isAdaptiveMenuOpen);
		}
	}

	useEffect(() => {
		console.log("isAdaptive: ", isAdaptiveMenuOpen);
	}, []);

	return (
		<div className={`header ${mode}`} ref={ref}>
			<div className="header__content">
				<div
					className="header__content_logo"
					onClick={() => navigate('/')}
				>
					<img
						className="icon__logo"
						src={`${process.env.PUBLIC_URL}/assets/images/Logo.svg`}
						alt={'Logo'}
					/>
					<img
						className="icon__title-logo"
						src={`${process.env.PUBLIC_URL}/assets/images/${mode === 'dark' ? 'LogoTitleLight.svg' : 'LogoTitleDark.svg'}`}
						alt={'Title logo'}
					/>
				</div>
				<div
					className={`header__content_menu ${mode} ${isAdaptiveMenuOpen && width > 768 ? !isOpen["products"] && !isOpen["company"] && 'open' : isAdaptiveMenuOpen ? 'open' : ''}`}
					ref={adaptiveRef}
				>
					<button
						ref={productsButtonRef}
						className={`header__content_button ${isOpen["products"] && 'opened'}`}
						onClick={() => handleOpened("products")}
						onMouseEnter={() => width > 767 && handleHoverOpened("products")}
					>
						<h4>Products</h4>
						{
							width > 767 ? (
								<RightDropdownArrow
									color={isOpen["products"] ? "#D6B0FF" : "#fff"}
									opacity={isOpen["products"] ? "1" : "0.3"}
								/>
							) : (
								<RightDropdownArrowMobile color={mode === 'dark' ? '#fff' : '#080015'} />
							)
						}
					</button>
					{
						width < 768 && (
							<div
								ref={productsRef}
								className={`header__description_mobile ${isOpen["products"] && 'open'}`}
								onMouseLeave={() => setIsOpen((prevState) => ({ ...prevState, products: false })) }
							>
								<div className={`header__description_mobile_products ${mode}`}>
									<HeaderProductsItemMobile
										title={"NFD Combine"}
										onPress={() => {
											window.open("https://combine.nfd.gg", "_blank");
										}}
										type={"Combine"}
										mode={mode}
									/>
									<HeaderProductsItemMobile
										title={"NFD Platform"}
										onPress={() => navigate('/nfd-platform')}
										type={"Platform"}
										mode={mode}
									/>
									<HeaderProductsItemMobile
										title={"Something Cool"}
										onPress={() => window.open("https://something.cool", "_blank")}
										type={"Something"}
										mode={mode}
									/>
									<HeaderProductsItemMobile
										title={"NFD Trading Bots"}
										onPress={() => navigate('/nfd-trade-bots')}
										type={"Trading"}
										mode={mode}
									/>
								</div>
							</div>
						)
					}
					{
						width < 768 && (
							<div className="header__description_line"></div>
						)
					}
					<button
						ref={companyButtonRef}
						className={`header__content_button ${isOpen["company"] && 'opened'}`}
						onClick={() => handleOpened("company")}
						onMouseEnter={() => width > 767 && handleHoverOpened("company")}
					>
						<h4>Company</h4>
						{
							width > 767 ? (
								<RightDropdownArrow
									color={isOpen["products"] ? "#D6B0FF" : "#fff"}
									opacity={isOpen["products"] ? "1" : "0.3"}
								/>
							) : (
								<RightDropdownArrowMobile color={mode === 'dark' ? '#fff' : '#080015'} />
							)
						}
					</button>
					{
						width < 768 && (
							<div className={`header__description_mobile_about ${mode} ${isOpen["company"] && 'open'}`}>
								<HeaderCompanyItem title={"About Us"} link={"about-us"} mode={mode} />
								<HeaderCompanyItem title={"Careers"} link={"careers"} mode={mode} />
								<HeaderCompanyItem title={"Brand Assets"} link={"brand-assets"} mode={mode} />
							</div>
						)
					}
					{
						width < 768 && (
							<div className="header__description_line"></div>
						)
					}
					{
						width < 768 && (
							<div className={`header__description_links_mobile ${mode}`}>
								<button className={`header__content_button`}>
									<h4>See also</h4>
								</button>
								<button className={`header__content_button`} onClick={() => window.open("https://cooldex.cool", "_blank")}>
									<h4>CoolDEX</h4>
									<RightProductArrow color={mode === 'dark' ? "#fff" : "#080015"} />
								</button>
								<button className={`header__content_button`}>
									<h4>GitBook</h4>
									<RightProductArrow color={mode === 'dark' ? "#fff" : "#080015"} />
								</button>
								{/*<button*/}
								{/*	className={`header__content_button`}*/}
								{/*	onClick={() => navigate('/blog')}*/}
								{/*>*/}
								{/*	<h4>Blog</h4>*/}
								{/*	<RightProductArrow color={mode === 'dark' ? "#fff" : "#080015"} />*/}
								{/*</button>*/}
							</div>
						)
					}
					{
						width < 768 && (
							<div className="header__description_line"></div>
						)
					}
					{
						width < 768 && (
							<div className={`header__socials_mobile ${mode}`}>
								<button className={`header__content_button`}>
									<h4>Socials</h4>
								</button>
								<div className="header__socials_mobile_items">
									<HeaderSocialItem
										title={"X"}
										link={"https://x.com/NFD_gg"}
										type={"Twitter"}
										mode={mode}
									/>
									<HeaderSocialItem
										title={"Discord"}
										link={"https://discord.gg/hfHb3AMHRP"}
										type={"Discord"}
										mode={mode}
									/>
									{/*<HeaderSocialItem*/}
									{/*	title={"YouTube"}*/}
									{/*	link={"https://www.youtube.com/"}*/}
									{/*	type={"YouTube"}*/}
									{/*	mode={mode}*/}
									{/*/>*/}
									<HeaderSocialItem
										title={"Telegram"}
										link={"https://t.me/NFD_Trading_Bots_Ann"}
										type={"Telegram"}
										mode={mode}
									/>
								</div>
							</div>
						)
					}
					{
						width > 767 && (
							<button
								className={"header__content_button"}
								onMouseEnter={() => handleHoverOpened("gitbook")}
							>
								<h4>GitBook</h4>
							</button>
						)
					}
					{
						width > 767 && (null
							// <button
							// 	className={"header__content_button"}
							// 	onMouseEnter={() => handleHoverOpened("blog")}
							// 	onClick={() => navigate('/blog')}
							// >
							// 	<h4>Blog</h4>
							// </button>
						)
					}
				</div>
				<div className={"header__content_burger"} >
					<button onClick={handlePressBurger}>
						<div className={`menu-bar ${isAdaptiveMenuOpen ? 'open' : 'close'}`}></div>
						<div className={`menu-bar ${isAdaptiveMenuOpen ? 'open' : 'close'}`}></div>
						<div className={`menu-bar ${isAdaptiveMenuOpen ? 'open' : 'close'}`}></div>
					</button>
				</div>
			</div>

			{
				width > 767 ? (
					<div
						ref={productsRef}
						className={`header__description ${isOpen["products"] && 'open'}`}
						onMouseLeave={() => width > 767 ? setIsOpen((prevState) => ({ ...prevState, products: false })) : null }
					>
						<div className={`header__description_products ${mode}`}>
							<HeaderProductsItem
								title={"NFD Combine"}
								description={"Manage your cryptocurrency wallets and farms, automate interactions with Web-3 projects and earn retros easily within a single application."}
								onPress={() => window.open("https://combine.nfd.gg", "_blank")}
								type={"Combine"}
								mode={mode}
							/>
							<HeaderProductsItem
								title={"NFD Platform"}
								description={"All Web-3 project activities worth your attention in one place."}
								onPress={() => navigate('/nfd-platform')}
								type={"Platform"}
								mode={mode}
							/>
							<HeaderProductsItem
								title={"Something Cool"}
								description={"A fair token launch platform that is changing the game."}
								onPress={() => window.open("https://something.cool", "_blank")}
								type={"Something"}
								mode={mode}
							/>
							<HeaderProductsItem
								title={"NFD Trading Bots"}
								description={"Trading bots inside Telegram. Gain instant access to trading various tokens across different networks."}
								onPress={() => navigate('/nfd-trade-bots')}
								type={"Trading"}
								mode={mode}
							/>
						</div>
						<div className={`header__description_links ${mode}`}>
							<h3>See also</h3>
							<div className={`line ${mode}`} />
							<button
								onMouseEnter={() => setIsHoveredSomeCool(true)}
								onMouseLeave={() => setIsHoveredSomeCool(false)}
								onClick={() => window.open("https://cooldex.cool", "_blank")}
							>
								<span>CoolDEX</span>
								<RightProductArrow
									color={
										mode === 'dark' ?
											isHoveredSomeCool ?
												"#D6B0FF"
												:
												"#fff"
											:
											isHoveredSomeCool ?
												"#7551FF"
												:
												"#080015"
									}
								/>
							</button>
						</div>
					</div>
				) : null
			}

			{
				width > 767 ? (
					<div className={`header__description_company ${isOpen["company"] && width > 767 && 'open'}`} >
						<div
							ref={companyRef}
							className="header__description_company_content"
							onMouseLeave={() => setIsOpen((prevState) => ({ ...prevState, company: false }))}
						>
							<div className={`header__description_about ${mode}`}>
								<HeaderCompanyItem title={"About Us"} link={"about-us"} mode={mode} />
								<HeaderCompanyItem title={"Careers"} link={"careers"} mode={mode} />
								<HeaderCompanyItem title={"Brand Assets"} link={"brand-assets"} mode={mode} />
							</div>
							<div className={`header__description_socials ${mode}`}>
								<h4>Socials</h4>
								<div className="header__description_socials_items">
									<HeaderSocialItem
										title={"X"}
										link={"https://x.com/NFD_gg"}
										type={"Twitter"}
										mode={mode}
									/>
									<HeaderSocialItem
										title={"Discord"}
										link={"https://discord.gg/hfHb3AMHRP"}
										type={"Discord"}
										mode={mode}
									/>
									{/*<HeaderSocialItem*/}
									{/*	title={"YouTube"}*/}
									{/*	link={"https://www.youtube.com/"}*/}
									{/*	type={"YouTube"}*/}
									{/*	mode={mode}*/}
									{/*/>*/}
									<HeaderSocialItem
										title={"Telegram"}
										link={"https://t.me/NFD_Trading_Bots_Ann"}
										type={"Telegram"}
										mode={mode}
									/>
								</div>
							</div>
						</div>
					</div>
				) : null
			}
		</div>
	);
});

export default Header;